<email-layout>
  <ng-container logo>
    <email-recruitee-logo />
  </ng-container>

  <ng-container header>
    <email-message-header [header]="data.title" [subheader]="data.description" />
  </ng-container>

  <ng-container body>
    <div class="technical-details-box">
      <email-text
        [contents]="data.technical_details_html"
        color="light"
        presetName="inline"
        size="small"
        className="web-rt-contains-link"
      />&nbsp;
    </div>
    <email-margin [height]="28" />
    <email-button [href]="data.go_to_settings_link" [label]="data.go_to_settings_text" />
  </ng-container>

  <ng-container footer>
    <email-text [contents]="data.need_help" color="light" presetName="inline" size="small" />&nbsp;
    <email-link
      [label]="data.support_email"
      [href]="data.support_email"
      [prefix]="'mailto:'"
      [textOpts]="{ size: 'small', color: 'light' }"
      textPreset="inline"
    />
  </ng-container>
</email-layout>
